import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Index from '../views/index.vue'
import Login from '../views/login.vue'
import { Message } from "element-ui"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'view-index',
        component: Index,
        children: [
            {
                path: '/',
                name: 'view-dashboard',
                component: () => import(/* webpackChunkName: 'view-dashboard' */ '../views/dashboard/index.vue')
            },
            {
                path: '/menu',
                name: 'view-menu',
                component: () => import(/* webpackChunkName: 'view-menu' */ '../views/menu/index.vue')
            },
            {
                path: '/admin',
                name: 'view-admin',
                component: () => import(/* webpackChunkName: 'view-admin' */ '../views/admin/index.vue')
            },
            {
                path: '/role',
                name: 'view-role',
                component: () => import(/* webpackChunkName: 'view-role' */ '../views/role/index.vue')
            },
            {
                path: '/member',
                name: 'view-member',
                component: () => import(/* webpackChunkName: 'view-member' */ '../views/member/index.vue')
            },
            {
                path: '/admin-log',
                name: 'view-admin-log',
                component: () => import(/* webpackChunkName: 'view-admin-log' */ '../views/admin-log/index.vue')
            },
            {
                path: '/open-door-records',
                name: 'view-open-door-records',
                component: () => import(/* webpackChunkName: 'view-open-door-records' */ '../views/open-door-records/index.vue')
            },
            {
                path: '/shop',
                name: 'view-shop',
                component: () => import(/* webpackChunkName: 'view-shop' */ '../views/shop/index.vue')
            },
            {
                path: '/article-type',
                name: 'view-article-type',
                component: () => import(/* webpackChunkName: 'view-article-type' */ '../views/article-type/index.vue')
            },
            {
                path: '/article',
                name: 'view-article',
                component: () => import(/* webpackChunkName: 'view-article' */ '../views/article/index.vue')
            },
            {
                path: '/system-config',
                name: 'view-system-config',
                component: () => import(/* webpackChunkName: 'view-system-config' */ '../views/system-config/index.vue')
            },
            {
                path: '/file',
                name: 'view-file',
                component: () => import(/* webpackChunkName: 'view-file' */ '../views/file/index.vue')
            },
            {
                path: '/archive',
                name: 'view-archive',
                component: () => import(/* webpackChunkName: 'view-archive' */ '../views/archive/index.vue')
            },
            {
                path: '/material',
                name: 'view-material',
                component: () => import(/* webpackChunkName: 'view-material' */ '../views/material/index.vue')
            },
            {
                path: '/reservation',
                name: 'view-reservation',
                component: () => import(/* webpackChunkName: 'view-reservation' */ '../views/reservation/index.vue')
            },
            {
                path: '/rfm',
                name: 'view-rfm',
                component: () => import(/* webpackChunkName: 'view-rfm' */ '../views/rfm/index.vue')
            },
            {
                path: '/rfm-setup',
                name: 'view-rfm-setup',
                component: () => import(/* webpackChunkName: 'view-rfm-setup' */ '../views/rfm-setup/index.vue')
            },
            {
                path: '/rfm-detail',
                name: 'view-rfm-detail',
                component: () => import(/* webpackChunkName: 'view-rfm-detail' */ '../views/rfm-detail/index.vue')
            },
            {
                path: '/issue-coupons',
                name: 'view-issue-coupons',
                component: () => import(/* webpackChunkName: 'view-issue-coupons' */ '../views/issue-coupons/index.vue')
            },
            {
                path: '/coupon',
                name: 'view-coupon',
                component: () => import(/* webpackChunkName: 'view-coupon' */ '../views/coupon/index.vue')
            },
            {
                path: '/goods',
                name: 'view-goods',
                component: () => import(/* webpackChunkName: 'view-goods' */ '../views/goods/index.vue')
            },
            {
                path: '/bi',
                name: 'view-bi',
                component: () => import(/* webpackChunkName: 'view-bi' */ '../views/bi/index.vue')
            },
            {
                path: '/goods/add',
                name: 'view-goods-add',
                component: () => import(/* webpackChunkName: 'view-goods-add' */ '../views/goods/add.vue')
            }, {
                path: '/goods/edit',
                name: 'view-goods-edit',
                component: () => import(/* webpackChunkName: 'view-goods-add' */ '../views/goods/edit.vue')
            },
            {
                path: '/goods-type',
                name: 'view-goods-type',
                component: () => import(/* webpackChunkName: 'view-goods-type' */ '../views/goods-type/index.vue')
            },
            {
                path: '/order',
                name: 'view-order',
                component: () => import(/* webpackChunkName: 'view-order' */ '../views/order/index.vue')
            }, {
                path: '/tihuo-order',
                name: 'tihuo-order',
                component: () => import(/* webpackChunkName: 'view-order' */ '../views/tihuo-order/index.vue')
            }, {
                path: '/banner',
                name: 'article-banner',
                component: () => import('../views/banner/index.vue')
            }, {
                path: '/assignment',
                name: 'article-assignment',
                component: () => import('../views/assignment/index.vue')
            }, {
                path: '/pick',
                name: 'article-pick',
                component: () => import('../views/selfpick/index.vue')
            }, {
                path: '/logistics',
                name: 'article-logistics',
                component: () => import('../views/logistics/index.vue')
            }, {
                path: '/aftersales',
                name: 'article-aftersales',
                component: () => import('../views/aftersales/index.vue')
            }, {
                path: '/agent',
                name: 'article-agent',
                component: () => import('../views/agent/index.vue')
            }, {
                path: '/evaluate',
                name: 'article-evaluate',
                component: () => import('../views/evaluate/index.vue')
            },
            {
                path: '/recommend-list',
                name: 'recommend-list',
                component: () => import('../views/recommend/recommend-list/index.vue')
            },
            {
                path: '/recommend-cate',
                name: 'recommend-cate',
                component: () => import('../views/recommend/recommend-cate/index.vue')
            },
            {
                path: '/scenic-list',
                name: 'scenic-list',
                component: () => import('../views/scenic/scenic-list/index.vue')
            },
            {
                path: '/scenic-cate',
                name: 'scenic-cate',
                component: () => import('../views/scenic/scenic-cate/index.vue')
            },
            {
                path: '/scenic-add',
                name: 'scenic-add',
                component: () => import('../views/scenic/scenic-list/add.vue')
            },
            {
                path: '/scenic-order',
                name: 'scenic-order',
                component: () => import('../views/scenic/scenic-order/index.vue')
            },
            {
                path: '/scenic-refund',
                name: 'scenic-refund',
                component: () => import('../views/scenic/scenic-refund/index.vue')
            },
            {
                path: '/school',
                name: 'school',
                component: () => import('../views/school/index.vue')
            },
            {
                path: '/school-label',
                name: 'school-label',
                component: () => import('../views/school-label/index.vue')
            },
            {
                path: '/middle-school',
                name: 'middle-school',
                component: () => import('../views/middle-school/index.vue')
            },
            {
                path: '/vip-order',
                name: 'vip-order',
                component: () => import('../views/vip-order/index.vue')
            },
            ,
            {
                path: '/ai-apply',
                name: 'ai-apply',
                component: () =>
                    import(
            /* webpackChunkName: 'view-feedback' */ "../views/ai-apply/ai-apply"
                    ),
            }, {
                path: '/box',
                name: 'box',
                component: () => import('../views/box/index.vue')
            }, {
                path: '/boxcate',
                name: 'boxcate',
                component: () => import('../views/box/boxcate.vue')
            }, {
                path: '/consumption',
                name: 'consumption',
                component: () => import('../views/consumption/index.vue')
            }, {
                path: '/changestore',
                name: 'changestore',
                component: () => import('../views/changestore/index.vue')
            }, {
                path: '/vip',
                name: 'vip',
                component: () => import('../views/vip/index.vue')
            }, {
                path: '/boxlist',
                name: 'boxlist',
                component: () => import('../views/boxlist/index.vue')
            }, {
                path: '/afterbox',
                name: 'afterbox',
                component: () => import('../views/afterbox/index.vue')
            }, {
                path: '/feedback',
                name: 'feedback',
                component: () => import('../views/feedback/index.vue')
            }, {
                path: '/boxevaluate',
                name: 'boxevaluate',
                component: () => import('../views/boxevaluate/index.vue')
            }, {
                path: '/pickcard',
                name: 'pickcard',
                component: () => import('../views/pickcard/index.vue')
            }, {
                path: '/notice',
                name: 'notice',
                component: () => import('../views/notice/index.vue')
            }, {
                path: '/help',
                name: 'help',
                component: () => import('../views/help/index.vue')
            }, {
                path: '/address-list',
                name: 'address-list',
                component: () => import('../views/address-list/index.vue')
            },
            {
                path: '/exchange-list',
                name: 'exchange-list',
                component: () => import('../views/exchange-list/index.vue')
            },
            {
                path: '/card-stock',
                name: 'card-stock',
                component: () => import('../views/card-stock/index.vue')
            },
            {
                path: '/goods-stock',
                name: 'goods-stock',
                component: () => import('../views/goods-stock/index.vue')
            },
            {
                path: '/ship-stock',
                name: 'ship-stock',
                component: () => import('../views/ship-stock/index.vue')
            },
            {
                path: '/cardstock-record',
                name: 'cardstock-record',
                component: () => import('../views/cardstock-record/index.vue')
            },
            {
                path: '/goodsstock-record',
                name: 'goodsstock-record',
                component: () => import('../views/goodsstock-record/index.vue')
            },
            {
                path: '/level',
                name: 'level',
                component: () => import('../views/level/index.vue')
            },
            {
                path: '/credit-apply',
                name: 'credit-apply',
                component: () => import('../views/credit-apply/index.vue')
            },
            {
                path: '/freight-template',
                name: 'freight-template',
                component: () => import('../views/freight-template/index.vue')
            },
            {
                path: '/stock-record',
                name: 'stock-record',
                component: () => import('../views/stock-record/index.vue')
            },
            {
                path: '/share-record',
                name: 'share-record',
                component: () => import('../views/share-record/index.vue')
            },
            {
                path: '/supplier',
                name: 'supplier',
                component: () => import('../views/supplier/index.vue')
            },
            {
                path: '/warehouse',
                name: 'warehouse',
                component: () => import('../views/warehouse/index.vue')
            },
            {
                path: '/recipe',
                name: 'recipe',
                component: () => import('../views/recipe/index.vue')
            },
            {
                path: '/purchase',
                name: 'purchase',
                component: () => import('../views/purchase/index.vue')
            },
            {
                path: '/process',
                name: 'process',
                component: () => import('../views/process/index.vue')
            },
            {
                path: '/inventory-apply',
                name: 'inventory-apply',
                component: () => import('../views/inventory-apply/index.vue')
            },
            {
                path: '/bi-product',
                name: 'bi-product',
                component: () => import('../views/bi-product/index.vue')
            },
            {
                path: '/bi-store',
                name: 'bi-store',
                component: () => import('../views/bi-store/index.vue')
            }
        ]
    },
    {
        path: '/login',
        name: 'view-login',
        component: Login
    },
    {
        path: '*',
        name: 'view-404',
        component: () => import(/* webpackChunkName: 'view-404' */ '../views/404.vue')
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path === "/rfm-detail") {
        if (store.state.buttons.findIndex(item => item.path === "rfm-detail") >= 0) {
            next();
        } else {
            Message.error("您没有该页面访问权限");
        }
    } else if (to.path === "/rfm-setup") {
        if (store.state.buttons.findIndex(item => item.path === "rfm-setup") >= 0) {
            next();
        } else {
            Message.error("您没有该页面访问权限");
        }
    } else {
        if (to.path !== '/login' && !store.state.token) {
            router.replace("/login");
        } else {
            next();
        }
    }
})

export default router
